import { cn } from 'shared/styles'

type Props = {
  text?: string
  rounded?: boolean
  wrapperClassNames?: string
  outerClassName?: string
  innerClassName?: string
  spinnerSize?: string
}

export function Spinner({
  text,
  rounded,
  wrapperClassNames,
  outerClassName,
  innerClassName,
  spinnerSize = 'size-2',
}: Props) {
  return (
    <div
      className={cn(
        'absolute inset-0 z-50 flex h-full items-center justify-center',
        outerClassName,
      )}
    >
      <div
        className={cn(
          'absolute inset-0 z-99 bg-white/60',
          rounded && 'rounded-md',
          wrapperClassNames,
        )}
      />
      <div
        className={cn(
          'z-100 grid animate-spin grid-cols-2 gap-1',
          innerClassName,
        )}
      >
        <div className={cn(spinnerSize, 'rounded-full bg-blue-400')} />
        <div className={cn(spinnerSize, 'rounded-full bg-blue-300')} />
        <div className={cn(spinnerSize, 'rounded-full bg-blue-200')} />
        <div className={cn(spinnerSize, 'rounded-full bg-blue-100')} />
      </div>
      {text && (
        <span className='ml-2.5 text-center text-3xl text-blue-500'>
          {text}
        </span>
      )}
    </div>
  )
}
